import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CompanyContext, RegulationContext } from "../../App";
import { LS_AUTHORITY_KEY, LS_REGULATION_SELECTED_KEY } from "../constants/common";
import CompanyService from "../service/CompanyService";
import RiskConfigService from "../service/RiskConfigService";
import Utils from "../utilities/Utils";

// Custom Hook for regulation related helpers
function useRegulationHelper() {

	const { setGlbRegulation, setGlbRegulations } = useContext(RegulationContext);
	const { glbCompany } = useContext(CompanyContext);
	const data = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const navigate = useNavigate();

	const getCompanyStandards = async () => {
		const companyId = data?.profile?.company?.id;
		if (!companyId) return;

		CompanyService.getCompanySubscriptions(companyId)
			.then((response) => {
				setGlbRegulations([...(response?.data?.regulations ?? [])]);
				if (response?.data?.regulations?.length > 0) {
					const lsRegSelect = localStorage.getItem(LS_REGULATION_SELECTED_KEY);
					if (lsRegSelect) {
						const selectedRegIndex = response?.data?.regulations.findIndex(x => x.id === +lsRegSelect);
						let selectedReg;
						if (selectedRegIndex >= 0) {
							selectedReg = response?.data?.regulations[selectedRegIndex];
						} else {
							selectedReg = response?.data?.regulations[0];
							localStorage.setItem(LS_REGULATION_SELECTED_KEY, selectedReg?.id);
						}
						setGlbRegulation(selectedReg);
						navigateToPageAfterSelectingStandard(selectedReg);
					} else {
						localStorage.setItem(LS_REGULATION_SELECTED_KEY, response?.data?.regulations[0].id);
						setGlbRegulation(response?.data?.regulations[0]);
						navigateToPageAfterSelectingStandard(response?.data?.regulations[0]);
					}
				}
			})
			.catch((error) => { });

	};

	const getSuperAdminRegulations = async () => {
		RiskConfigService.getRegulationsByStatus("PUBLISHED")
			.then((response) => {
				setGlbRegulations([...response.data]);
				setGlbRegulation(response.data.length > 0 ? response.data[0] : "");
			})
			.catch((error) => { });
	};

	const getSupplierRegulations = async () => {
		if (data.profile.company == undefined) {
			return
		}
		const companyId = data.profile.company.id;
		const selCompanyContext = glbCompany.companyId ? glbCompany.companyId : '';
		if (glbCompany.companyId > 0 && companyId) {
			const string = Utils.generateUrlParamCompanyRegulationWithSupplier(
				selCompanyContext,
				null,
				companyId
			);
			const encodedParam = Utils.encodeBase64(string);
			CompanyService.getCompanyContextRegulations(encodedParam)
				.then((response) => {
					setGlbRegulations([...response.data]);
					setGlbRegulation(response.data.length > 0 ? response.data[0] : "");
				})
				.catch((error) => { });
		} else if (glbCompany.companyId === -1) {
			CompanyService.getSupplierAccessibleRegulations()
				.then((response) => {
					setGlbRegulations([...response.data]);
					setGlbRegulation(response.data.length > 0 ? response.data[0] : "");
				})
				.catch((error) => { });
		}

	};

	const navigateToPageAfterSelectingStandard = (item) => {
		const pathname = window.location.pathname;
		if (pathname === '/company_admin/standard'
			|| pathname === '/company_admin/configurations') {
			if (item.type === 'S') {
				navigate("/company_admin/standard");
			} else {
				navigate("/company_admin/configurations");
			}
		} else if (pathname === '/company_admin/dataview'
			|| pathname === '/company_admin/risk_supplier_list') {
			if (item.type === 'S') {
				navigate("/company_admin/dataview");
			} else {
				navigate("/company_admin/risk_supplier_list");
			}
		}
	}

	return {
		getCompanyStandards,
		getSupplierRegulations,
		navigateToPageAfterSelectingStandard
	};
};


export default useRegulationHelper;